<template>
  <component
    :is="currentAdComponent"
    v-if="ads"
    :ads="ads"
    :search-query="searchQuery"
    />
</template>

<script>
import PowerLink from "./PowerLink.vue";
import PowerContent from "./PowerContent.vue";

export default {
  name: 'NaverAd',
  components: { PowerLink, PowerContent },
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    adType: {
      type: String,
      default: 'powerLink',
      validator: (value) => ['powerLink', 'powerContents'].includes(value)
    },
    adData: {
      type: Object,
      default: null
    }
  },
  computed: {
    currentAdComponent() {
      return this.adType === 'powerContents' ? 'PowerContent' : 'PowerLink';
    },
    ads() {
      return this.adData?.ads || null;
    }
  },
}
</script>